export const companySlugParser = (companySlug) => {
  const slugFormat = /^((\d+)-)?(.+)$/;
  const matches = slugFormat.exec(companySlug);
  return matches.slice(-2);
};
